/* eslint-disable import/prefer-default-export */
import { RESET_TERRAZO_FIELDS } from './types';

export const resetTerrazoFields = () => ({
  type: RESET_TERRAZO_FIELDS,
});
